/**
 * Truncates product description by word count; shows "Read more" to reveal full HTML.
 * Controlled via data-word-limit on [data-product-description-truncate] (set in main-product.liquid).
 */
(function () {
  var SELECTOR = '[data-product-description-truncate]';

  function getWords(text) {
    return text.replace(/\s+/g, ' ').trim().split(/\s+/).filter(Boolean);
  }

  function truncateContainer(container) {
    var limit = parseInt(container.getAttribute('data-word-limit') || '50', 10);
    if (!limit || limit < 1) return;

    var readMoreLabel = container.getAttribute('data-read-more') || 'Read more';
    var fullHtml = container.innerHTML;
    if (!fullHtml || !fullHtml.trim()) return;

    var words = getWords(container.textContent || '');
    if (words.length <= limit) return;

    var excerptText = words.slice(0, limit).join(' ') + '\u2026';

    var excerptEl = document.createElement('div');
    excerptEl.className = 'product-info__description-excerpt';
    excerptEl.textContent = excerptText;

    var fullEl = document.createElement('div');
    fullEl.className = 'product-info__description-full rte';
    fullEl.hidden = true;
    fullEl.innerHTML = fullHtml;

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'product-info__description-readmore';
    toggle.textContent = readMoreLabel;

    toggle.addEventListener('click', function () {
      excerptEl.hidden = true;
      toggle.hidden = true;
      fullEl.hidden = false;
    });

    container.innerHTML = '';
    container.appendChild(excerptEl);
    container.appendChild(toggle);
    container.appendChild(fullEl);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(truncateContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
